import { IconButton, Tooltip, useDialog, useTranslationContext } from 'platform/components';
import { suffixTestId, TestIdProps } from 'shared/web';
import { selectQueryId } from '../../../../store/createEagGridStore';
import { useEagGridSelector } from '../../../../store/useEagGridSelector';
import { ExportDialog } from './components/ExportDialog/ExportDialog';
type ExportButtonProps = TestIdProps;
export function ExportButton(props: ExportButtonProps) {
  const t = useTranslationContext();
  const [isOpen, onOpen, onClose] = useDialog();
  const queryId = useEagGridSelector(selectQueryId);
  return <>
      <Tooltip label={t('page.datagrid.button.export')}>
        <IconButton icon="file/download" onClick={onOpen} aria-label={t('page.datagrid.button.export')} isDisabled={!queryId} data-testid={suffixTestId('exportButton', props)} />
      </Tooltip>
      <ExportDialog isOpen={isOpen} onClose={onClose} data-testid={suffixTestId('exportButton', props)} />
    </>;
}